import { render, staticRenderFns } from "./DeviationColorsEditor.vue?vue&type=template&id=bb10f1ec&scoped=true"
import script from "./DeviationColorsEditor.vue?vue&type=script&lang=js"
export * from "./DeviationColorsEditor.vue?vue&type=script&lang=js"
import style0 from "./DeviationColorsEditor.vue?vue&type=style&index=0&id=bb10f1ec&prod&lang=scss"
import style1 from "./DeviationColorsEditor.vue?vue&type=style&index=1&id=bb10f1ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb10f1ec",
  null
  
)

export default component.exports